import BuyerLayout from "../components/Layout";
import { useGetIdParam } from "../../SharedComponents/hooks/useGetIdParam";
import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { getCar } from "../reduxStore/entities/userCars";
import { useEffect } from "react";
import BaseButton from "../../SharedComponents/components/Buttons/BaseButton";
import { useNavigate } from "react-router-dom";
import { ButtonVariantEnum } from "../../SharedComponents/utils/enums/ButtonVariantEnum";
import UserCarImageVisualizer from "../components/UserCarComponents/UserCarImageVisualizer";
import UserCarDescriptionCard from "../components/UserCarComponents/UserCarDescriptionCard";
import ActiveRequestTable from "../components/Tables/Table/ActiveRequestsTable";
import UnActiveRequestsTable from "../components/Tables/Table/UnActiveRequestsTable";

const UserCar = () => {
    const idParam = useGetIdParam();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchedUserCar = useSelector((state) => state.userCars.singleCar);
    const isLoaded = useSelector((state) => state.userCars.singleCarLoaded);

    useEffect(() => {
        dispatch(getCar(idParam));
    }, [idParam]);

    if (!isLoaded) {
        return null;
    }

    const userCarBreadcrumbs = [
        { title: "Početak", href: "/home" },
        { title: fetchedUserCar.title }
    ];

    const EndComponent = () => {
        return (
            <BaseButton
                text="Posalji zahtev"
                onClick={() => navigate('/')}
                variant={ButtonVariantEnum.BLACK}
            />
        );
    };

    return (
        <BuyerLayout>
            <Breadcrumb
                title={fetchedUserCar.title}
                breadcrumbs={userCarBreadcrumbs}
                EndComponent={EndComponent}
            />

            <div style={styles.upperRow}>
                <UserCarImageVisualizer
                    carMake={fetchedUserCar.Make.name}
                    images={fetchedUserCar.UserCarImages}
                />
                <UserCarDescriptionCard userCar={fetchedUserCar} />
            </div>

            <div style={styles.sectionSpacing}>
                <ActiveRequestTable id={idParam} />
            </div>

            <div style={styles.sectionSpacing}>
                <UnActiveRequestsTable id={idParam} />
            </div>
        </BuyerLayout>
    );
};

export default UserCar;

const styles = {
    upperRow: {
        marginTop: 10,
        display: 'flex',
        gap: 20,
    },
    sectionSpacing: {
        marginTop: 40,
    },
};
